import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";

export default function FTP({ attorney }: { attorney: APIModels.Attorney }) {
    const never = "never" as const;
    const [ftpinfo, setftpinfo] = useState([] as APIModels.FTPInfo[]);

    useEffect(() => {
        AttorneyService.getFTPInfo({ attorneyId: attorney.id ?? "" }).then(
            (resp) => {
                if (resp.successful === true) {
                    setftpinfo(resp.data!);
                } else {
                    console.log("Error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "Credential Hash",
                                field: "credentialsHash",
                            },
                            {
                                title: "Url",
                                field: "url",
                            },
                            {
                                title: "Port",
                                field: "port",
                            },
                            {
                                title: "Append Client Matter",
                                field: "appendClientMatter",
                                type: "boolean" as const,
                            },
                            {
                                title: "Active",
                                field: "active",
                                type: "boolean" as const,
                            },
                        ]}
                        data={ftpinfo}
                        title="FTP"
                    />
                </div>
            </div>
        </div>
    );
}
